import { BACKEND_URL } from "./apiConfig";

export async function verifyVenueAvailability(schedule) {
  const response = await fetch(`${BACKEND_URL}/api/venue-bookings/availability`, {
    method: "POST", headers: { "Content-Type": "application/json" },
    body: JSON.stringify(schedule),
  });
  if (!response.ok) throw new Error("Unable to verify venue availability. Please try again.");
  const data = await response.json();
  if (typeof data.available !== "boolean") throw new Error("Unable to verify venue availability. Please try again.");
  return data.available;
}
